/**
 * Portal Manta · FonteKpiBadge
 * Extraído de App.jsx (v29 modular)
 */
import React, { useState, useEffect, useMemo, useCallback, Fragment, memo } from 'react';
import { M, F, STATUS } from '../../tokens/theme.js';
import { FONTE_KPI_STYLES } from '../../app-globals.js';

const FonteKpiBadge = memo(function FonteKpiBadge_Inner({fonte}){
  if (!fonte) return (<span style={{fontFamily:F.mono, fontSize:9.5, color:'#9CA3AF'}}>—</span>);
  const s = FONTE_KPI_STYLES[fonte] || FONTE_KPI_STYLES.manual;
  return (<span style={{
    display:'inline-block', padding:'1px 7px', background:s.bg, color:s.fg,
    fontSize:9.5, fontFamily:F.mono, fontWeight:600, letterSpacing:.3,
    borderRadius:2, textTransform:'lowercase',
  }}>{s.label}</span>);
});

export { FonteKpiBadge };
export default FonteKpiBadge;
